import api, { API_BASE, defaultOpt } from "./apiService";
import { rowTransform } from "./tableUtils";

export async function getAllRemote() {
  return (await api.get(`${API_BASE}/list-remote`)).data;
}

export async function addRemote(formAdd) {
  return (await api.post(`${API_BASE}/add-remote`, formAdd, defaultOpt()))
    .data;
}

export async function deleteRemote(id) {
  return (await api.delete(`${API_BASE}/delete-remote/${id}`, defaultOpt()))
    .data;
}

export async function updateRemote(id, form) {
  return (await api.put(`${API_BASE}/edit-remote/${id}`, form, defaultOpt()))
    .data;
}

export function makeRemoteOptions(remoteList) {
  return rowTransform(remoteList, (ship) => ({
    value: ship.id,
    label: `${ship.id} (${ship.box_desc})`,
  }));
}

